import React, { useState, useEffect, useRef } from "react"

import { Form } from "react-bootstrap"

import InputField from './elements/input'
import SelectField from './elements/select'
import FileField from './elements/file'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import { postFormData } from "./api/Api"
//import bsCustomFileInput from 'bs-custom-file-input'
import $ from "jquery"
import axios from "axios"
import * as qs from "query-string"
import _ from "lodash";

function GlobalPopUpForm(props) {
  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");
  const [file, setFile] = useState(""); // storing the uploaded file

  const myRef = useRef(null);

  const recaptchaRef = useRef(null);

  const fields = ([
      {
        element: "config",
        formname: "Register your interest",
        form_type: "register-your-intrest",
        error_text: "Highlighted fields are required",
        success_text: "Thank you for contacting us. A member of our team will contact you shortly.",
        email_temp_user: "global_popup_user",
        email_temp_admin: "global_popup_admin",
        email_subject_user:"Thank you for your interest in our Guide",
        email_subject_admin:"Thank you for your interest in our Guide",
        email_server_func: "register_your_interest",
        event_tracking: "register-your-intrest",
        page_url: "/general-enquiry"
      },      
      {
        grpmd: "12",
        label: "Name",
        placeholder: "Enter your name here",
        name: "name",
        type: "text",
        element: "input",
        class:"form__field",
        required: true,
        patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
        labelClass: "content_b-18",
        page: 1
      },
      {
        grpmd: "12",
        label: "Email Address",
        placeholder: "Enter your email here",
        name: "email",
        type: "email",
        element: "input",
        class:"form__field",
        required: true,
        patternchk:"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
        labelClass: "content_b-18",
        page: 1
      },
      {
        grpmd: "12",
        label: "I'd like to receive information about...",
        name: "preferences",
        element: "preferences",
        class: "form__preferences",
        required: true,
        page: 1,
        options: [
          { label: "Selling (Market updates, selling tips)", value: "selling" },
          { label: "Lettings (Rental market trends, Renters' Rights Act updates)", value: "lettings" },
          { label: "Buying (Buying guides, off-market opportunities)", value: "buying" },
          { label: "Landlords & property investment (Buy-to-lets, income strategy)", value: "landlords" },
          { label: "Community & local events (DA trails, community spotlights, local news)", value: "community" }
        ]
      },
      {
        grpmd: "12",
        label: "I have read and agree to the Terms and Conditions, Privacy Policy and Cookies Policy",
        name: "agree_terms",
        type: "checkbox",
        element: "checkbox",
        class: "form__checkbox",
        required: true,
        page: 1
      },
      
      {
        grpmd: "12",
        name: "Submit",
        type:"submit",
        element: "button",
        value: "submit",
        labelClass: "content_b-18",
        page: 1
      },
      
      {
        element: "captcha",
        class: "py-2",
        captchaRef: recaptchaRef
      },
    ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }
  const handleselectchange = event => {
    // remove initial empty spaces
    event.value = event.value.trimStart()
  }

  const handleAttachment = event => {
    const fileItem = event.target.files[0]; // accesing file

    var d = document.getElementById('custom-file');
    //alert(d.value);
    if (d.value != "") {
      $('.form-control-browsefile .custom-file-label').html(d.value.replace(/C:\\fakepath\\/, ''));
    } else {
      $('.form-control-browsefile .custom-file-label').html("Click to upload your CV");
    }

    setFile(fileItem); // storing file 
  };
  
  useEffect(() => {
    $(".form-field-group input").blur(function(){
      $(".form-field-group input").each(function(){
        if ($(this).is(":invalid")) {
          $(this).closest(".form-field-group").addClass("invalid--field");
        } else {
          $(this).closest(".form-field-group").removeClass("invalid--field");
        }      
      })
    });

    if (token !== '') {
      const processFromData = async () => {
      
      formvalues['g-recaptcha-response'] = token;
      
      let formData = new FormData();

      formvalues['name'] = formvalues.name;
      formvalues['email_subject_user'] = fields[0].email_subject_user;
      formvalues['email_subject_admin'] = fields[0].email_subject_admin;

      formData.append('data', JSON.stringify(formvalues));
      

      postFormData(formData).then(async apiRes => {
      
        try {
          if (recaptchaRef.current && typeof recaptchaRef.current.reset === 'function') {
            recaptchaRef.current.reset();
          } else if (window.grecaptcha && typeof window.grecaptcha.reset === 'function') {
            window.grecaptcha.reset();
          } else {
            console.warn('reCAPTCHA reset not available');
          }
        } catch (err) {
          console.warn('reCAPTCHA reset failed (ignored):', err);
        }

        // lets send mail
        await window.fetch(`${process.env.GATSBY_CLOUD_URL}/api/form`, {
          method: `POST`,
          mode: "no-cors",
          headers: {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: qs.stringify(formvalues),
        })

      });

      const url = typeof window !== 'undefined' ? window.location.href : ''  
      
      // tracking event
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'formSubmit',
        'formType': 'form-'+fields[0].event_tracking,
        'formId': 'form-'+fields[0].event_tracking,
        'formName': fields[0].formname,
        'formLabel': fields[0].formname
      });

      setShowerror(false);
      setThankyou(true);
      setCurrentPage(2);
      
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    setToken(token);
  };

  const handleSubmit = event => {

    if ((file == '') || (file == null)) {
      $('.form-control-browsefile').addClass('fileerror');
    } else {
      $('.form-control-browsefile').removeClass('fileerror');
    }

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      $(".form-field-group input").each(function(){
        if ($(this).is(":invalid")) {
          $(this).closest(".form-field-group").addClass("invalid--field");
        } else {
          $(this).closest(".form-field-group").removeClass("invalid--field");
        }      
      })
      
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    else {

      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))

      // Handle preferences
      const preferences = [];
      document.querySelectorAll('input[name="preferences[]"]:checked').forEach(checkbox => {
        preferences.push(checkbox.value);
      });
      json['preferences'] = preferences.join(', ');

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      json['extra'] = _.omit(json, ["formname", "name", "email", "agree_terms", "form_name", "formName", "form_type", "to_email_id", "bot-field", "preferences"])

      json['files'] = file;
      setFile(file);

      setFormvalues(json);

      if (recaptchaRef.current && typeof recaptchaRef.current.execute === 'function') {
        console.log('global-popup: executing reCAPTCHA');
        recaptchaRef.current.execute();
      } else {
        console.warn('global-popup: reCAPTCHA ref missing or execute() unavailable. Manual fallback.');
      }

      setValidated(false);

      // reset form
      const form = event.target
      form.reset();
      
    }
  };

  return (
    <div className="form stbform common_form_class" id="contactform">
    <div ref={myRef} />

    {showthankyou ? (
      // Page 2: Thank You Page
      <div className="form-wraps thank-you-page">
        <div className="thank-you-content">
          <h2 className="thank-you-title">Thank you!</h2>
          <p className="thank-you-message">Your download should have started, if not click the button below to download the guide.</p>
          <a href="https://ggfx-davidastburys.s3.eu-west-2.amazonaws.com/i.prod/Updated_Navigating_The_Renters_Rights_Act_78c57da8e7.pdf" target="_blank" download className="btn btn-primary download-guide-btn">
            Download the <br/>Renters' Rights Guide
          </a>
          <br/>
          <h3 className="social-heading">Join the conversation.</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/davidastburys/?hl=en-gb" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.266.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1 1 12.324 0 6.162 6.162 0 0 1-12.324 0zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm4.965-10.322a1.44 1.44 0 1 1 2.881.001 1.44 1.44 0 0 1-2.881-.001z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/DavidAstburysEstateAgency/?locale=en_GB" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22 2h-4a6 6 0 0 0-6 6v4H8v4h4v8h4v-8h3l1-4h-4V8a2 2 0 0 1 2-2h4z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/company/david-astburys?originalSubdomain=uk" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.475-2.236-1.986-2.236-1.081 0-1.722.731-2.004 1.438-.103.249-.129.597-.129.946v5.421h-3.554s.047-8.733 0-9.635h3.554v1.365c.429-.658 1.191-1.595 2.897-1.595 2.117 0 3.704 1.385 3.704 4.362v5.503zM5.337 9.433c-1.144 0-1.915-.758-1.915-1.704 0-.951.77-1.708 1.971-1.708 1.2 0 1.912.757 1.937 1.704 0 .946-.737 1.708-1.993 1.708zm1.582 11.019H3.656V9.817h3.263v10.635zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.225 0z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    ) : (
      // Page 1: Form
      <div>
        {showerror && <div className="alert-error">
          <p>{fields[0].error_text}</p>
        </div>}

        <div className="form-wraps input-wraps">
          <Form className="contact-form form-w-label" name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit}>
            <input type="hidden" name="form_name" value={fields[0].formname} />
            <input type="hidden" name="formName" value={fields[0].formname} />
            <input type="hidden" name="form_type" value={fields[0].form_type} />
            <input type="hidden" name="to_email_id" value={props.to_email_id} />
            <input type="hidden" name="bot-field" />
            
            {fields.map((field, index) => {
                // Skip config and captcha fields in regular rendering
                if (field.element === "config" || field.element === "captcha") return null;
                
                // Skip fields not meant for current page
                if (field.page && field.page !== currentPage) return null;

                if ( "input" === field.element ) {
                  return (
                    <InputField
                      name={field.name}
                      grpmd={field.grpmd}
                      ref={field.ref}
                      type={field.type}
                      fieldClass={field.class}
                      placeholder={field.placeholder}
                      label={field.label}
                      labelClass={field.labelClass}
                      required={field.required}
                      key={`${field.element}~${index}`}
                      pattern={field.patternchk}
                      handlechange={handlechange}
                    />
                  );
                }
                if ("file" === field.element) {
                  return (
                    <FileField
                      name={field.name}
                      grpmd={field.grpmd}
                      ref={field.ref}
                      label={field.label}
                      type={field.type}
                      fieldClass={field.fieldClass}
                      labelClass={field.labelClass}
                      placeholder={field.placeholder}
                      key={`${field.element}~${index}`}
                      accept={field.accept}
                      handlechange={handleAttachment}
                      required={field.required}
                    />
                  );
                }
                if ("select" === field.element) {
                  return (
                    <SelectField
                      name={field.name}
                      grpmd={field.grpmd}
                      label={field.label}
                      ref={field.ref}
                      required={field.required}
                      fieldClass={field.class}
                      placeholder={field.placeholder}
                      values={field.values}
                      key={`${field.element}~${index}`}
                      handlechange={handleselectchange}
                      componentprops={props}
                    />
                  );
                }
                if ("textarea" === field.element) {
                  return (
                    <TextAreaField
                      name={field.name}
                      grpmd={field.grpmd}
                      ref={field.ref}
                      rows={field.rows}
                      fieldClass={field.class}
                      label={field.label}
                      labelClass={field.labelClass}
                      placeholder={field.placeholder}
                      required={field.required}
                      key={`${field.element}~${index}`}
                      handlechange={handlechange}
                    />
                  );
                }
                if ("checkbox" === field.element) {
                  return (
                    <div key={`${field.name}~${index}`} className={`form-group ${field.class}`}>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={field.name}
                          name={field.name}
                          value="yes"
                          required={field.required}
                          onChange={handlechange}
                        />
                        <label className="form-check-label" htmlFor={field.name}>
                          {field.label}
                        </label>
                      </div>
                    </div>
                  );
                }
                if ("preferences" === field.element) {
                  return (
                    <div key={`${field.element}~${index}`} className="form-group">
                      <label>{field.label}</label>
                      <div className={field.class}>
                        {field.options.map((option, optIndex) => (
                          <div key={`preference-${optIndex}`} className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`pref-${option.value}`}
                              name={`${field.name}[]`}
                              value={option.value}
                              onChange={handlechange}
                            />
                            <label className="form-check-label" htmlFor={`pref-${option.value}`}>
                              {option.label}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }
                if ("radio" === field.element) {
                  return (
                    <RadioField
                      name={field.name}
                      ref={field.ref}
                      value={field.value}
                      fieldClass={field.class}
                      checked={field.checked}
                      placeholder={field.placeholder}
                      required={field.required}
                      key={`${field.name}~${index}`}
                      handlechange={handlechange}
                      lastchild={field.lastchild}
                    />
                  );
                }
                if ("html" === field.element) {
                  return (
                    <HtmlBox
                      text={field.text}
                      fieldClass={field.class}
                      key={`${field.element}~${index}`}
                    />
                  );
                }
                if ("button" === field.element) {
                  return (
                    <ButtonField
                      name={field.name}
                      fieldClass={field.class}
                      type={field.type}
                      value={field.value}
                      key={`${field.element}~${index}`}
                    />
                  );
                }
              })
            }
            {/* Render captcha for current page */}
            {fields.map((field, index) => {
              if (field.element === "captcha" && (currentPage === 1 || !field.page)) {
                return (
                  <ReCaptchaBox
                    fieldClass={field.class}
                    captRef={field.captchaRef}
                    key={`${field.element}~${index}`}
                    handleonVerify={handleonVerify}
                  />
                );
              }
            })}
          </Form>
        </div>
      </div>
    )}
    </div>
  );
}


const ContactForm = (props) => (
  <GlobalPopUpForm to_email_id={props.to_email_id}  formtype={props.formtype}  />
)

export default ContactForm
